var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.proceed.apply(null, arguments)
        },
        keydown: function($event) {
          return _vm.payItemForm.errors.clear($event.target.name)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _vm.hasRole("admin")
          ? _c("div", { staticClass: "col-12 col-sm-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("MDA")]),
                  _vm._v(" "),
                  _c("v-select", {
                    class: {
                      "form-control is-invalid": _vm.payItemForm.errors.has(
                        "mda_id"
                      )
                    },
                    attrs: {
                      options: _vm.mdas,
                      reduce: function(name) {
                        return name.id
                      },
                      label: "name",
                      name: "mda_id"
                    },
                    model: {
                      value: _vm.payItemForm.mda_id,
                      callback: function($$v) {
                        _vm.$set(_vm.payItemForm, "mda_id", $$v)
                      },
                      expression: "payItemForm.mda_id"
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "mda_id"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Name")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.payItemForm.name,
                    expression: "payItemForm.name"
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.payItemForm.errors.has("name") },
                attrs: { type: "text", name: "name", placeholder: "Name" },
                domProps: { value: _vm.payItemForm.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.payItemForm, "name", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: { "form-name": _vm.payItemForm, "prop-name": "name" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Amount")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.payItemForm.amount,
                    expression: "payItemForm.amount"
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.payItemForm.errors.has("amount") },
                attrs: { type: "text", name: "amount", placeholder: "Amount" },
                domProps: { value: _vm.payItemForm.amount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.payItemForm, "amount", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: { "form-name": _vm.payItemForm, "prop-name": "amount" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.hasRole("admin")
          ? _c("div", { staticClass: "col-12 col-sm-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Service Type ID")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payItemForm.service_type_id,
                        expression: "payItemForm.service_type_id"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.payItemForm.errors.has(
                        "service_type_id"
                      )
                    },
                    attrs: {
                      type: "text",
                      name: "service_type_id",
                      placeholder: "Service Type ID"
                    },
                    domProps: { value: _vm.payItemForm.service_type_id },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payItemForm,
                          "service_type_id",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "service_type_id"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Is Fixed Amount?")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.payItemForm.is_fixed,
                      expression: "payItemForm.is_fixed"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "is-invalid": _vm.payItemForm.errors.has("is_fixed")
                  },
                  attrs: { name: "is_fixed" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.payItemForm,
                        "is_fixed",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "0" } }, [_vm._v("No")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "1" } }, [_vm._v("Yes")])
                ]
              ),
              _vm._v(" "),
              _c("show-error", {
                attrs: { "form-name": _vm.payItemForm, "prop-name": "is_fixed" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.hasRole("admin")
          ? _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Has Developer Charges?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payItemForm.has_developer_charges,
                          expression: "payItemForm.has_developer_charges"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "is-invalid": _vm.payItemForm.errors.has(
                          "has_developer_charges"
                        )
                      },
                      attrs: { name: "has_developer_charges" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.payItemForm,
                            "has_developer_charges",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "0" } }, [_vm._v("No")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [_vm._v("Yes")])
                    ]
                  ),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "has_developer_charges"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasRole("admin")
          ? _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Has Contribution Charges?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payItemForm.has_contribution_charges,
                          expression: "payItemForm.has_contribution_charges"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "is-invalid": _vm.payItemForm.errors.has(
                          "has_contribution_charges"
                        )
                      },
                      attrs: { name: "has_contribution_charges" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.payItemForm,
                            "has_contribution_charges",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "0" } }, [_vm._v("No")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [_vm._v("Yes")])
                    ]
                  ),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "has_contribution_charges"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasRole("admin") &&
        Number(_vm.payItemForm.has_developer_charges) === 1
          ? _c("div", { staticClass: "col-12 col-sm-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Developer Amount")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payItemForm.developer_amount,
                        expression: "payItemForm.developer_amount"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.payItemForm.errors.has(
                        "developer_amount"
                      )
                    },
                    attrs: {
                      type: "text",
                      name: "developer_amount",
                      placeholder: "Developer Amount"
                    },
                    domProps: { value: _vm.payItemForm.developer_amount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payItemForm,
                          "developer_amount",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "developer_amount"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasRole("admin") &&
        Number(_vm.payItemForm.has_contribution_charges) === 1
          ? _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Accreditation Amount")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payItemForm.accreditation_amount,
                        expression: "payItemForm.accreditation_amount"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.payItemForm.errors.has(
                        "accreditation_amount"
                      )
                    },
                    attrs: {
                      type: "text",
                      name: "accreditation_amount",
                      placeholder: "Accreditation Amount"
                    },
                    domProps: { value: _vm.payItemForm.accreditation_amount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payItemForm,
                          "accreditation_amount",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "accreditation_amount"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasRole("admin") &&
        Number(_vm.payItemForm.has_contribution_charges) === 1
          ? _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Health Scheme Amount")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payItemForm.health_scheme_amount,
                        expression: "payItemForm.health_scheme_amount"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.payItemForm.errors.has(
                        "health_scheme_amount"
                      )
                    },
                    attrs: {
                      type: "text",
                      name: "health_scheme_amount",
                      placeholder: "Health Scheme Amount"
                    },
                    domProps: { value: _vm.payItemForm.health_scheme_amount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payItemForm,
                          "health_scheme_amount",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "health_scheme_amount"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasRole("admin") &&
        Number(_vm.payItemForm.has_contribution_charges) === 1
          ? _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("TRCN Amount")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payItemForm.trcn_amount,
                        expression: "payItemForm.trcn_amount"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.payItemForm.errors.has("trcn_amount")
                    },
                    attrs: {
                      type: "text",
                      name: "trcn_amount",
                      placeholder: "TRCN Amount"
                    },
                    domProps: { value: _vm.payItemForm.trcn_amount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payItemForm,
                          "trcn_amount",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "trcn_amount"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasRole("admin")
          ? _c("div", { staticClass: "col-12 col-sm-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Hilinks Fixed Charge")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payItemForm.hilinks_charge,
                        expression: "payItemForm.hilinks_charge"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.payItemForm.errors.has("hilinks_charge")
                    },
                    attrs: {
                      type: "text",
                      name: "hilinks_charge",
                      placeholder: "Hilinks Fixed Charge"
                    },
                    domProps: { value: _vm.payItemForm.hilinks_charge },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payItemForm,
                          "hilinks_charge",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "hilinks_charge"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasRole("admin")
          ? _c("div", { staticClass: "col-12 col-sm-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Hilinks Revenue Percentage")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payItemForm.hilinks_revenue_percentage,
                        expression: "payItemForm.hilinks_revenue_percentage"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.payItemForm.errors.has(
                        "hilinks_revenue_percentage"
                      )
                    },
                    attrs: {
                      type: "text",
                      name: "hilinks_revenue_percentage",
                      placeholder: "Hilinks Revenue Percentage"
                    },
                    domProps: {
                      value: _vm.payItemForm.hilinks_revenue_percentage
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payItemForm,
                          "hilinks_revenue_percentage",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.payItemForm,
                      "prop-name": "hilinks_revenue_percentage"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right",
          attrs: { type: "submit" }
        },
        [
          _vm.id
            ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
            : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          directives: [
            { name: "show", rawName: "v-show", value: _vm.id, expression: "id" }
          ],
          staticClass:
            "btn btn-danger waves-effect waves-light pull-right mr-1 mb-1",
          attrs: { to: "/setting/pay-item" }
        },
        [_vm._v(_vm._s(_vm.trans("general.cancel")))]
      ),
      _vm._v(" "),
      !_vm.id
        ? _c(
            "button",
            {
              staticClass:
                "btn btn-danger waves-effect waves-light pull-right mr-1 mb-1",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [_vm._v(_vm._s(_vm.trans("general.cancel")))]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }